import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { useCustomerId } from 'features/customers/hooks/useCustomerId'

import type { DeliveriesPage, DeliveriesQuery, DeliveryEventRecord } from '@albacross/types'

import { get, type HttpError } from 'utils/http'

export const useCustomerDeliveries = (query: DeliveriesQuery) => {
  const customerId = useCustomerId()

  return useQuery<DeliveriesPage, HttpError>({
    queryKey: ['customer', customerId, 'deliveries', query],
    queryFn: () => get(`/management/customers/${customerId}/deliveries`, { query }),
    placeholderData: keepPreviousData,
  })
}

export const useDeliveryEvents = (deliveryId: number) => {
  const customerId = useCustomerId()

  return useQuery<DeliveryEventRecord[], HttpError>({
    queryKey: ['customer', customerId, 'deliveries', deliveryId, 'events'],
    queryFn: () => get(`/management/customers/${customerId}/deliveries/${deliveryId}/events`),
  })
}
